import { LoadingView } from '@payflip/ui/v2';
import { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { useAuthenticate } from '../use-authenticate';

export function PrivateRoutes(): ReactNode {
  const { isSynchingStore } = useAuthenticate();
  return isSynchingStore ? <LoadingView fixed /> : <Outlet />;
}
